import { designTokens } from '@kmns-internal/furikake/tokens'
import { FormControlLabel, Switch } from '@mui/material'
import { FC } from 'react'

type OptionToggleSwitchProps = {
  isChecked: boolean
  onChange: (checked: boolean) => void
  label: string
  isDisabled?: boolean
}

export const OptionToggleSwitch: FC<OptionToggleSwitchProps> = ({
  isChecked,
  onChange,
  label,
  isDisabled = false,
}) => (
  <FormControlLabel
    control={
      <Switch
        checked={isChecked}
        onChange={e => onChange(e.target.checked)}
        disabled={isDisabled}
        color="primary"
        size="medium"
        sx={{
          '& .MuiSwitch-track': {
            backgroundColor: designTokens.colors.components.switchSlideFill,
          },
          // disabled状態のトラック背景色
          '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: designTokens.colors.action.disabledBackground,
          },
        }}
      />
    }
    label={label}
    sx={{
      marginLeft: 0,
    }}
  />
)
